export class IndicatorChartArgs {
    constructor(gr, advArgsParams, window) {
        this.gr = gr;
        this.advArgsParams = advArgsParams;
        this.window = window;
    }
}
